import { render, staticRenderFns } from "./EditStep1.vue?vue&type=template&id=38b8e934"
import script from "./EditStep1.vue?vue&type=script&lang=js"
export * from "./EditStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports